import styled from '@emotion/styled';
import { colors } from '../../../utils/styleguide';

const SkeletonText = styled.span`
  display: inline-block;
  position: relative;
  ::after {
    content: ''; // ::before and ::after both require content
    position: absolute;
    top: 10%;
    left: 0;
    width: 100%;
    height: 80%;
    background-color: ${colors.gray};
    border-radius: 2px;
  }
`;

export default SkeletonText;
